import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAsync, Async } from '../components/Async';
import { ScorersList } from '../components/ScorersList';
import { BackLink, Muted } from '../components/ui';

export function Scorers() {
  const navigate = useNavigate();
  const state = useAsync(() => api.scorers(), [], '/scorers');
  return (
    <>
      <BackLink onClick={() => navigate(-1)}>← Volver</BackLink>
      <h2 style={{ marginTop: 0 }}>🥇 Goleadores</h2>
      <Muted style={{ marginBottom: 12 }}>No incluye goles en contra. (p) = penales.</Muted>
      <Async state={state}>{(d) => <ScorersList scorers={d.scorers} />}</Async>
    </>
  );
}
